import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";

const mapToOptions = (data, labelKey = 'name', valueKey = 'code') => {
  return data.map(item => ({ label: item[labelKey], value: item[valueKey] }));
};

export const getQuizFromServer = async () => {
  try {
    const response = await axiosInstance.get("quizzes", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData;
    }
    return [];
  } catch (error) {
    console.error("Error fetching Quizzes:", error);
    throw new Error("Failed to fetch Quizzes");
  }
};

export const getCourse = async () => {
  try {
    const response = await axiosInstance.get("courses/list", { 
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response?.data?.encryptedData) {
                const decryptedData = TokenDecrypt(response.data.encryptedData);
                if (decryptedData?.data) {
                  console.log("decryptedData?.data",decryptedData?.data);
                  
                  return mapToOptions(decryptedData.data, 'title', 'id');
                }
              }
              return [];
  } catch (error) {
    console.error("Error fetching Course :", error);
    throw new Error("Failed to fetch Category");
  }
};

export const addQuiz = async (quizData) => {
  try {
    const jsonData = Object.fromEntries(quizData.entries());
    const response = await axiosInstance.post("quizzes", jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response
  } catch (error) {
    console.error("Error adding Quiz:", error);
    throw new Error("Failed add Quiz");
  }
};

export const getQuiz = async (id) => {
  try {
    const response = await axiosInstance.get(`quizzes/publish/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response
  } catch (error) {
    console.error("Error Publishing Quiz :", error);
    throw new Error("Failed to Publishing Quiz");
  }
};

export const getQue = async (id, isSelectedQue) => {
  try {
    const response = await axiosInstance.get(`questions/list?quizId=${id}&isSelectedQuestions=${isSelectedQue}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data
  } catch (error) {
    console.error("Error Featching Questions :", error);
    throw new Error("Failed to Featch Questions");
  }
};

export const publishQuiz = async (id) => {
  try {
    const response = await axiosInstance.put(`/quizzes/publish/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error publishing quiz:", error);
    throw error;
  }
};

export const mapQuestionsToQuiz = async (id, questionIds) => {
  try {
    const response = await axiosInstance.post(`/quizzes/${id}/map-questions`, {
      questionIds,
    });
    return response.data;
  } catch (error) {
    console.error('Error mapping questions to quiz:', error);
    throw error;
  }
};

export const getQuizByIdFromServer = async (id) => {
  try {
    const response = await axiosInstance.get(`quizzes/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching Quiz with ID ${id}:`, error);
    throw new Error("Failed to fetch Quiz");
  }
};

export const updateQuiz = async (quizId, quizData) => {
  try {
    const jsonData = Object.fromEntries(quizData.entries());
    const response = await axiosInstance.put(`quizzes/${quizId}`, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating quiz:", error);
    throw error;
  }
};

export const deleteQuiz = async (id) => {
  try {
    const response = await axiosInstance.delete(`/quizzes/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete Quiz.";
    console.error("Error in Question:", errorMessage);
    throw new Error(errorMessage);
  }
};